import script from "./YellowRadioButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./YellowRadioButton.vue?vue&type=script&setup=true&lang=ts"

import "./YellowRadioButton.vue?vue&type=style&index=0&id=63b6346a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b6346a"]])

export default __exports__